module.exports = __webpack_public_path__ + "static/media/garmin-logo-text.d01fb276.svg";